<template>
  <v-app app class="app-background">
    <v-row class="m-0">
      <AppBar class="py-0 px-4" :username="username.user" :useremail="username.useremail" :userinit="username.userinitial" />
     <NavBar class="hero-image" v-if="unauthorized===false" />
      <v-col cols="12" class="onScreenSizeChange">
        <v-main style="padding-left: 60px !important;padding-top: 70px !important;">
          <v-sheet class="bg-transparent">
            <v-container fluid>
              <router-view v-if="loggedInSuccess===true" />
              <unAuthorized v-else-if="loggedInSuccess===false" />
            </v-container>
          </v-sheet>
        </v-main>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import NavBar from "@/components/templates/NavBar.vue";
import AppBar from '@/components/templates/AppBar.vue'
//Please remember to replace <YOUR_BRAND> in the below link, with your desire brand name, which can be one of these: maeu, hamburgsud, safm.
import "@maersk-global/fonts/maeu/fonts.css";
//Please remember to replace <YOUR_BRAND> in the below path, with your desire brand name, which can be one of these: maersk, hamburgsud, or sealand.
import "@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css";
//You can also import `@maersk-global/mds-foundations/css/foundations.css`, only if you need some global stylesheet i.e. CSS resets, classes that support our typography and table styles.
import '@maersk-global/mds-foundations/css/foundations.css';

import "@maersk-global/mds-components-core/mc-button";
import "@maersk-global/mds-components-core/mc-icon";
import '@mdi/font/css/materialdesignicons.css' // Ensure you are

import { mapGetters, mapState } from "vuex";
import * as msal from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { AV_REQUEST_SCOPES, LOGIN_REQUEST_SCOPES } from "@/config/constants";
import { store } from "./store/store.js";
import { getMsalIdToken } from "@/utils/helpers";
import {avActions} from "@/actions";
import unAuthorized from '@/views/unAuthorized.vue'

export default {
  name: 'App',
  components: {
    AppBar,
    NavBar,
    unAuthorized,
  },
  store,
  data() {
    return {
      currentYear: new Date().getFullYear(),
      hasError: false,
      retryRequest: true,
      loggedInSuccess: undefined,
      unauthorized: undefined,
      msalLibrary: {},
      account: {},
      username: {
        user: "",
        useremail: "",
        userinitial: ""
      }
    }
  },
  computed: {
    ...mapState(["accessToken"]),
    ...mapGetters({
      user: "user"
    }),
    user: {
      get() {
        const { account } = this.$store.getters.getTokenData;
        return {
          jobTitle: "",
          mail: account?.username || "",
          displayName: account?.name || ""
        };
      },
      set(userData) {
        return userData;
      }
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$changeIsLoadingOptions({
        slot: `
      <div class="px-5 py-3 bg-gray-800 rounded">
        <h3 class="text-3xl text-white"><i class="fas fa-spinner fa-spin"></i> ${this.$t("message.loading")}</h3>
      </div>
    `
      });
    }
  },
  async created() {
    this.msalLibrary = new PublicClientApplication(this.$store.state.msalConfig);
    await this.msalLibrary
        .handleRedirectPromise()
        .then(this.handleResponse)
        .catch((error) => {
          console.log(error);
          this.hasError = true;
        });
  },
  mounted() {
    const accounts = this.msalLibrary.getAllAccounts();
    this.account = accounts ? accounts[0] : null;
    // const eventBus = inject('signOutEventBus');
    // eventBus.$on('appBarSignOut', this.signOut());
  },
  methods: {
    async signIn() {
      return this.msalLibrary
          .loginRedirect(LOGIN_REQUEST_SCOPES)
          .then(this.handleResponse)
          .catch(function (error) {
            console.error(error);
          });
    },
    async signOut() {
      await this.msalLibrary
          .logout({})
          .then(() => {
            localStorage.clear(); // For Clearing Local Storage
            sessionStorage.clear(); // For Clearing Session Storage
            this.loggedInSuccess = false; //uncomment during deployment
            document.cookie.split(";").forEach(function (c) {
              // For Clearing the Cookies
              document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
          })
          .catch((error) => {
            console.error(error);
          });
    },
    async handleResponse(resp) {
      if (resp !== null) {
        try {
          const currentAccounts = this.msalLibrary.getAllAccounts();
          const accountId = currentAccounts[0]?.homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);

          const avScopeResponse = await this.getTokenRedirect(
              AV_REQUEST_SCOPES,
              currentAcc
          ).catch((error) => {
            console.log(error);
          });
          await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
          sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
          AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
          const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
          this.username.user = token.account.name == null ? "" : token.account.name;
          this.username.useremail = token.account.username == null ? "" : token.account.username;
          this.username.userinitial =
              token.account.name == null
                  ? ""
                  : token.account.name.split(" ")[0].charAt(0) +
                  token.account.name.split(" ")[1].charAt(0);
          sessionStorage.setItem("userEmail", this.username.useremail.toLowerCase());
          this.$store.commit("setUserEmail", this.username.useremail.toLowerCase());
          await this.checkAuthorization(token.idToken, token.account.username);
        } catch(error){
          if (error.response.status === 400 && this.retryRequest) {
            this.retryRequest = false;
          } else if (error.response.status === 401) {
            await getMsalIdToken();
          }
        }
      } else {
        const currentAccounts = this.msalLibrary.getAllAccounts();
        this.account = currentAccounts[0];
        if (!currentAccounts || currentAccounts.length < 1) {
          await this.signIn();
        } else {
          const accountId = currentAccounts[0].homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);
          if (currentAcc) {
            const avScopeResponse = await this.getTokenRedirect(
                AV_REQUEST_SCOPES,
                currentAcc
            ).catch((error) => {
              console.log(error);
            });

            await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
            sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
            AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
            const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
            this.username.user = token.account.name == null ? "" : token.account.name;
            this.username.useremail = token.account.username == null ? "" : token.account.username;
            this.username.userinitial =
                token.account.name == null
                    ? ""
                    : token.account.name.split(" ")[0].charAt(0) +
                    token.account.name.split(" ")[1].charAt(0);
            this.$store.commit("setUserEmail", this.username.useremail.toLowerCase());
            await this.checkAuthorization(token.idToken, token.account.username);
          }
        }
      }
    },
    async saveUserActivity(idToken, accountId){
      const postBody = {
        "userEmail": accountId,
        "userRole": sessionStorage.getItem("memberRole")
      }
      const saveOptions = await avActions.saveUserActivityDetails(
          postBody,
          idToken
      );
      const response = await AxiosFetchForMsal(saveOptions);
      if (response.status === 200) {
        console.info("user activity saved successfully.");
      } else {
        console.error("error occurred while saving user activity.");
      }
    },
    async checkAuthorization(idToken, accountId) {
      const userInfo = {
        "userEmail": accountId.toLowerCase()
      }
      const options = await avActions.authorizeUserList(
          userInfo,
          idToken
      );
      const response = await AxiosFetchForMsal(options);
      if (response.status === 200) {
        sessionStorage.setItem("memberRole", response.data.memberRole);
        sessionStorage.setItem("memberStatus", response.data.status);
        await this.saveUserActivity(idToken, accountId.toLowerCase());
        this.unauthorized = false;
        this.loggedInSuccess = true;
      }else if (response.status === 401) {
        sessionStorage.setItem("memberRole", response.data.memberRole);
        sessionStorage.setItem("memberStatus", response.data.status);
        this.loggedInSuccess = false;
        this.unauthorized = true;
      }else{
        sessionStorage.setItem("memberRole", response.data.memberRole);
        sessionStorage.setItem("memberStatus", response.data.status);
        this.loggedInSuccess = false;
        this.unauthorized = false;
      }
    },

    async getTokenRedirect(request, account) {
      request.account = account;
      return this.msalLibrary
          .acquireTokenSilent(request)
          .catch(async (error) => {
            console.log("silent token acquisition fails.");
            if (error instanceof msal.InteractionRequiredAuthError) {
              console.log("acquiring token using redirect");
              this.msalLibrary.acquireTokenRedirect(request);
            } else {
              console.error(error);
            }
          });
    }
  }
}
</script>

<style>
.shrink-cells tr th,
.shrink-cells tr td{
  padding: 2px 2px !important;
  height: auto !important;
}

.shrink-secondary-cells tr th,
.shrink-secondary-cells tr td{
  padding: 8px !important;
  height: auto !important;
}

.shrink-cells .child-table-td{
  background: #d3e3fd !important;
}

.v-theme--light.v-table thead{
  background: #dbdbdb !important;
}

.custom-table thead .v-data-table__td,
.custom-table tbody .v-data-table__td{
  height: auto !important;
  padding: 10px !important;
}

.onScreenSizeChange{
  padding: 0 !important;
  background: #f1f1f1 !important;
}

.v-table th .v-data-table-header__content span{
  font-weight: bolder !important;
}

.v-container {
  margin-left: auto;
  margin-right: auto;
  padding: 20px 30px 20px 20px !important;
  width: 100%;
}

html {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback) !important;
}

.p-0{
  padding: 0 !important;
}

.p-10{
  padding: 10px !important;
}

#stockStatusFlagTable .v-table__wrapper table tr:nth-child(even) {
  background-color: #f1f1f1 !important;
}

#stockStatusFlagTable .v-table__wrapper table tr:nth-child(even) td {
  font-weight: bold !important;
}

#edit-scenario-page .mc-step-indicator-scenario .current span{
  font-weight : 700;
}

#view-scenario-page .mc-step-indicator-scenario .completed span{
  font-weight : 700;
}

.infleet-data-table tr:last-child{
  background: #f1f1f1 !important;
}

.infleet-data-table tr:last-child span{
 font-weight: 700 !important;
}

.m-0{
  margin: 0 !important;
}

.main-panel-div{
  background: #f7f7f7;
  padding: 10px;
  border: 1px solid rgb(219, 219, 219);
  border-radius: 10px;
}

.child-table-td{
  padding: 10px !important;
  background: rgb(241 241 241);
}
.table-all-border{
  border: 1px solid rgb(219, 219, 219);
  border-radius: 0px;
}

#sep-region-table td{
  text-align : left !important;
}

#stockStatusFlagTable .v-data-table-column--align-left{
  text-align: left !important;
}

.forecastDrySplitTableID tbody tr:nth-child(1) .v-data-table__td--expanded-row .v-btn,
#bh-volume-split-table tbody tr:nth-child(1) .v-data-table__td--expanded-row .v-btn,
.inFleet-container-volume-table tbody tr:nth-child(1) .v-data-table__td--expanded-row .v-btn{
  display: none !important;
}

.forecastDrySplitTableID tbody tr:nth-child(1).v-data-table__tr,
#turn-time-table tbody tr:nth-child(1),
#bh-volume-split-table tbody tr:nth-child(1).v-data-table__tr,
.inFleet-container-volume-table tbody tr:nth-child(1).v-data-table__tr{
  background-color: #f5f5f5; /* Light gray background */
  font-weight: bold; /* Bold text */
}

.total-row-addition tbody tr:nth-child(1) .v-data-table__td--expanded-row .v-btn{
  display: none !important;
}
.total-row-addition tbody tr:nth-child(1).v-data-table__tr{
  background-color: #f5f5f5;
  font-weight: bold;
}

.remove-tr-bg tbody tr:nth-child(1).v-data-table__tr {
  background: transparent;
  font-weight: normal;
}

.forecast-volume-region-table tbody tr,
#bh-region-split-table tbody tr,
.inFleet-region-volume-table tbody tr{
  background-color: transparent !important;
  font-weight: normal !important;
}


.copy-values-row{
  position: absolute;
  right: -15px;
  top: 10px;
  cursor: pointer;
  margin: 5px;
}

#forty-region-volume-table .v-data-table__td,
#twenty-region-volume-table .v-data-table__td{
  position : relative ;
}

.position-relative{
  position: relative !important;
}

.view-stages-check {
  cursor: pointer;
}

.margin-top-20{
  margin-top: 20px;
}

.mtb-10{
  margin: 10px 0 !important;
}

.actual-vs-forecast-region-table tr td,
.actual-vs-forecast-region-table tr th{
  text-align: left !important;
  padding: 5px !important;
}

.actual-vs-forecast-region-table .forecast-delta-volume-span {
  background: #cccccc73;
  display: block !important;
}


.actual-vs-forecast-container-type-table tr th{
  text-align: left !important;
  padding: 0 5px !important;
}
.actual-vs-forecast-container-type-table tr td{
  padding: 10px 0 !important;
}

.actual-vs-forecast-container-type-table td .split-string-value:nth-child(3){
  background: #cccccc73 !important;
}

.actual-vs-forecast-container-type-table td .split-string-value{
  display: inline-block !important;
  padding: 0 5px !important;
}

.actual-vs-forecast-container-type-table .split-string-value-delta {
  margin-left: -5px !important;
}

.chart-bar-actual-forecast mc-icon::part(icon) {
  cursor: pointer;
  fill: #42b0d5
}

.chart-bars-vertical-align .mc-icon{
  display: contents !important;
}

.chart-bars-vertical-align	{
  display: block !important ;
  width: 100% !important ;
  margin-left: 15px;
}

.chart-bar-actual-forecast {
  display: block !important ;
}

.margin-right-10{
  margin-right: 10px !important;
}

.margin-right-minus-10{
  margin-right: -10px !important;
}

.d-block{
  display: block !important;
}

.margin-left-10{
  margin-left: 10px !important;
}



/* SEP CSS */
.margin-top-24{
  margin-top: 24px;
}

.padding-0{
  padding: 0 !important;
}

.margin-10{
  margin: 10px !important;
}

.sep-page .lostDemandInfoTable .v-table__wrapper {
  background: #ffffff !important;
}

.sep-page .v-theme--light.v-table thead,
.sep-page .v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th{
  background: #dbdbdb !important;
}

.margin-rl-10{
  margin: 0 10px;
}

.padding-top-0{
  padding-top: 0 !important;
}

#utilizationTableId thead,
#moveCountTableId thead{
  background-color: #e9f6fc !important;
}

.cursor-pointer {
  cursor: pointer;
}

#utilizationTableId tbody tr td,
#moveCountTableId tbody tr td{
  padding: 5px !important;
}

.p-5{
  padding: 5px !important;
}

#utilizationTableId tbody tr td:nth-child(3),
#utilizationTableId tbody tr td:nth-child(4),
#utilizationTableId tbody tr td:nth-child(5),
#utilizationTableId tbody tr td:nth-child(6),
#utilizationTableId tbody tr td:nth-child(7),
#utilizationTableId tbody tr td:nth-child(8),
#utilizationTableId thead tr th:nth-child(3),
#utilizationTableId thead tr th:nth-child(4),
#utilizationTableId thead tr th:nth-child(5),
#utilizationTableId thead tr th:nth-child(6),
#utilizationTableId thead tr th:nth-child(7),
#utilizationTableId thead tr th:nth-child(8){
  background-color: #cecece38;
}

#moveCountTableId tbody tr td:nth-child(6),
#moveCountTableId tbody tr td:nth-child(7),
#moveCountTableId tbody tr td:nth-child(8),
#moveCountTableId thead tr th:nth-child(6),
#moveCountTableId thead tr th:nth-child(7),
#moveCountTableId thead tr th:nth-child(8){
  background-color: #cecece38;
}


#utilizationTableId tbody tr td:nth-child(4),
#utilizationTableId tbody tr td:nth-child(5),
#utilizationTableId tbody tr td:nth-child(7),
#utilizationTableId tbody tr td:nth-child(8),
#utilizationTableId tbody tr td:nth-child(10),
#utilizationTableId tbody tr td:nth-child(11),
#utilizationTableId tbody tr td:nth-child(13),
#utilizationTableId tbody tr td:nth-child(14),
#utilizationTableId thead tr th:nth-child(4),
#utilizationTableId thead tr th:nth-child(5),
#utilizationTableId thead tr th:nth-child(7),
#utilizationTableId thead tr th:nth-child(8),
#utilizationTableId thead tr th:nth-child(10),
#utilizationTableId thead tr th:nth-child(11),
#utilizationTableId thead tr th:nth-child(13),
#utilizationTableId thead tr th:nth-child(14){
  text-align: center;
}

#moveCountTableId tbody tr td:nth-child(3),
#moveCountTableId tbody tr td:nth-child(4),
#moveCountTableId tbody tr td:nth-child(5),
#moveCountTableId tbody tr td:nth-child(7),
#moveCountTableId tbody tr td:nth-child(8),
#moveCountTableId tbody tr td:nth-child(10),
#moveCountTableId tbody tr td:nth-child(11),
#moveCountTableId thead tr th:nth-child(3),
#moveCountTableId thead tr th:nth-child(4),
#moveCountTableId thead tr th:nth-child(5),
#moveCountTableId thead tr th:nth-child(7),
#moveCountTableId thead tr th:nth-child(8),
#moveCountTableId thead tr th:nth-child(10),
#moveCountTableId thead tr th:nth-child(11){
  text-align: center;
}

#utilizationTableId tbody tr td:nth-child(3),
#utilizationTableId tbody tr td:nth-child(6),
#utilizationTableId tbody tr td:nth-child(9),
#utilizationTableId tbody tr td:nth-child(12),
#utilizationTableId thead tr th:nth-child(3),
#utilizationTableId thead tr th:nth-child(6),
#utilizationTableId thead tr th:nth-child(9),
#utilizationTableId thead tr th:nth-child(12){
  text-align: right;
}

#moveCountTableId tbody tr td:nth-child(6),
#moveCountTableId tbody tr td:nth-child(9),
#moveCountTableId thead tr th:nth-child(6),
#moveCountTableId thead tr th:nth-child(9){
  text-align: right;
}

.margin-top-10{
  margin-top: 10px !important;
}

.highlight {
  background-color: #f0f8ff; /* Light blue background */
}

.bg-highlight {
  background-color: #ffeeba;
}
/* Scoped or global depending on where your styles are */
.sticky-first-column table > tbody > tr > td:nth-child(1),
.sticky-first-column table > thead > tr > th:nth-child(1){
  position: sticky;
  left: 0;
  background-color: white; /* Ensure background isn't transparent */
  z-index: 2; /* Ensure it stays above other columns */
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1); /* Optional shadow */
}

/* Optional: higher z-index for header cell */
.sticky-first-column table > thead > tr > th:nth-child(1){
  z-index: 3;
}
</style>
